import React, { useState } from "react";
import { Outlet, Link } from "react-router-dom";
import { FaBars, FaTimes, FaHome, FaBook, FaUsers } from "react-icons/fa";
import Navbar from "./Navbar";
import BottomNav from "./BottomNav";

const navLinks = [
  { id: "Dashboard", title: "Dashboard", path: "/" },
  {
    id: "Masters",
    title: "Masters",
    path: "/Masters",
    submenu: [
      { id: "web-dev", title: "Web Development", path: "/services/web-dev" },
      { id: "seo", title: "SEO Optimization", path: "/services/seo" },
    ],
  },
  {
    id: "Admissions Management",
    title: "Admissions Management",
    path: "/Admissions Management",
    submenu: [
      { id: "app-dev", title: "App Development", path: "/services/app-dev" },
      {
        id: "digital-mkt",
        title: "Digital Marketing",
        path: "/services/digital-mkt",
      },
    ],
  },
  { id: "about", title: "About Us", path: "/about" },
  { id: "contact", title: "Contact Us", path: "/contact" },
];


function Layout() {
  return (
    <div className="flex w-screen h-screen">
      {/* Sidebar - Initially hidden */}
      {/* Main Content */}
      <div className="flex-1 flex flex-col w-screen h-screen ">
        {/* Top Navigation Bar with Dropdown Menu */}
        <Navbar />
        {/* Page Content */}
        <div className="w-screen h-screen p-0 overflow-y-auto pt-20 pb-18 bg-slate-50/50">
          <Outlet />
        </div>

        {/* Bottom Navigation Bar */}
        <BottomNav />

      </div>
    </div>
  );
}

export default Layout;
